import { Props } from "."

export const mockProps: Props = {
  href: "#",
  children: "Click me",
}
